let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fFgLm")).then(() => parcelRequire('7bDNN'));